import Image from "./Image";
// RentShield brand palette — a modern, trust-forward insurance identity.
export const NAVY = "#0E1A38"; // primary dark / structure
export const NAVY_SOFT = "#16244A"; // slightly lifted navy for cards on dark
export const CORAL = "#F52C52"; // RentShield brand accent — CTAs & highlights
export const CORAL_DARK = "#D91F43"; // hover state for coral
export const CORAL_SOFT = "#FCD9E0"; // light coral fill (e.g. checkmark badges)
export const GREEN = "#16B981"; // "covered" ticks
// Brand neutrals
export const BLACK = "#000000"; // brand black (fills + text)
/**
 * RentShield wordmark lockup. Pass tone="light" on dark backgrounds.
 */
export function RentShieldMark({ tone = "dark", size = "default", className = "", }) {
    const isLight = tone === "light";
    const heightClass = isLight ? "h-11" : size === "lg" ? "h-12 sm:h-14" : "h-9";
    return (<span className={`inline-flex items-center ${className}`}>
      <Image src="/images/rentshield/rentshield-logo.svg" alt="RentShield" width={233} height={107} priority className={`${heightClass} w-auto${isLight ? " brightness-0 invert" : ""}`}/>
    </span>);
}
